"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelEntryFormStateV1Schema = exports.FormPinAssignmentV1Schema = exports.PinBlockRefV1Schema = exports.PkgParameterV1Schema = exports.SIGMA_MODEL_ENTRY_FORM_V1_VERSION = void 0;
exports.migrateSigmaModelEntryFormV1ToLatest = migrateSigmaModelEntryFormV1ToLatest;
const z = require("zod");
const form_latest_1 = require("./form-latest");
exports.SIGMA_MODEL_ENTRY_FORM_V1_VERSION = 'sigma-model-entry-form/v1';
exports.PkgParameterV1Schema = z.object({
    value: z.string().nullable(),
    variance: z.string().nullable(),
});
exports.PinBlockRefV1Schema = z.object({
    name: z.string().min(1),
    index: z.number().int().nonnegative(),
});
exports.FormPinAssignmentV1Schema = z.object({
    modelSignalId: z.string(),
    block: exports.PinBlockRefV1Schema.nullable(),
    nameOverride: z.string().nullable(),
    pins: z.string().array(),
    packageSignalId: z.string().optional(),
});
exports.SigmaModelEntryFormStateV1Schema = z.object({
    formVersion: z.literal(exports.SIGMA_MODEL_ENTRY_FORM_V1_VERSION),
    parentSigmaModelType: z.string(),
    elementSigmaModelType: z.string().nullable(),
    pinCount: z.number().int().nullable(),
    arrayConfirmed: z.boolean().nullable(),
    pinAssignments: exports.FormPinAssignmentV1Schema.array(),
    ncPins: z.string().array(),
    parameters: z.record(z.string(), exports.PkgParameterV1Schema),
});
function migrateSigmaModelEntryFormV1ToLatest(formData) {
    return {
        ...formData,
        formVersion: form_latest_1.SIGMA_MODEL_ENTRY_FORM_LATEST_VERSION,
        pinAssignments: formData.pinAssignments.map((assignment) => ({ ...assignment })),
        ncPins: [...formData.ncPins],
    };
}
//# sourceMappingURL=form-v1.js.map